module.exports = __webpack_public_path__ + "static/garden-0b7167ee9d5e2da810df475c56fe3831.jpg";